import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextLip= () => {

return(
<div>
    
<Typography variant="h6" >
<br />
Hyperlipidemia (high cholesterol) is an excess of lipids or fats in your blood. This can increase your risk of heart attack and stroke because blood can’t flow through your arteries easily. 
Adding exercise and healthy foods can lower your cholesterol. Some people need medication as well. Managing your cholesterol is a long-term effort.
<br /><br /> 
Think of cholesterol, a kind of fat, as traveling in lipoprotein cars through your blood.<br /><br /> 

Low-density lipoprotein (LDL) is known as bad cholesterol because it can clog your arteries like a large truck that broke down and is blocking a traffic lane. (Borderline high number: 130 mg/dL to 159 mg/dL. High: 160 mg/dL to 189 mg/dL.)
<br /><br /> Very low-density lipoprotein (VLDL) is also called bad because it carries triglycerides that add to artery plaque. This is another type of traffic blocker.
<br /><br /> High-density lipoprotein (HDL) is known as good cholesterol because it brings cholesterol to your liver, which gets rid of it. 
This is like the tow truck that removes the broken down vehicles from the traffic lanes so vehicles can move. In this case, it’s clearing the way for your blood to get through your blood vessels. 
For your HDL, you don’t want to have a number lower than 40 mg/dL.

<br /> <br /> 


<Typography component="span" variant="h5" sx={{fontWeight: '600'}}>Associated Genes: </Typography>
<br /><br />
'CETP', 'CYP27A1', 'ABCA1', 'ANGPTL3', 'GPD1', 'APOA1', 'GPIHBP1', 'APOC2', 'LCAT', 'LIPA', 'LPL', 'LRP6', 'MTTP', 'SAR1B', 'PNPLA2', 'ABCG5', 'ABCG8', 'LMF1', 'CREB3L3', 'LIPG', 'SORT1', 
 'LPL', 'CYP7A1', 'GCKR', 'LIPG', 'NPC1L1', 'ANGPTL4', 'FRIC', 'ABCG5', 'ABCG8' 
<br /><br /> 
 
</Typography>

</div>
)
}